"use client"

/**
 * Client island for the /soil-temperature-map page. Only the leaflet map
 * lives here; every SEO-relevant block (summary, thresholds, methodology,
 * FAQ) is server-rendered in page.tsx so it lands in crawlable static HTML.
 *
 * Defaults to the timing-status mode: the standalone page's promise is the
 * pre-emergent verdict, not the raw temperature.
 */

import dynamic from "next/dynamic"

const NationalSoilMap = dynamic(
  () => import("@/app/tools/soil-temperature/components/national-soil-map").then((m) => ({ default: m.NationalSoilMap })),
  {
    ssr: false,
    loading: () => (
      <div className="relative h-[420px] w-full animate-pulse overflow-hidden rounded-lg border border-gray-200 bg-gray-100" />
    ),
  },
)

export function MapIsland() {
  // Caption suppressed: the hero directly above already shows "Last updated".
  return <NationalSoilMap defaultMode="status" showUpdatedCaption={false} />
}
